// extracted by mini-css-extract-plugin
export default {"orderDashboardContainer":"f6Ok7fOY2p29cFaR7MY2","orderMiniDashboardContainer":"IgfKwxKgJhtYPdjIsE4y"};